import React from "react";
import {IItemTimeline, PolymorphicItem} from "../../tevapi/interfaces";
import {Timeline, Typography} from "antd";
import {useQuery} from "@tanstack/react-query";
import {TEVService} from "../../tevapi/io";
import {LoadingAnimation} from "../loading-page";


const TimelineEvent: React.FC<{event: IItemTimeline}> = ({event}) => {
  return (
    <>
      <Typography.Title level={5}>
        {new Date(event.timestamp).toString()}
      </Typography.Title>
      <Typography.Paragraph>
        {event.message}
      </Typography.Paragraph>
    </>
  );
};


export const ItemTimeline: React.FC<{item: PolymorphicItem}> = ({item}) => {

  const timelineQuery = useQuery({
    queryKey: ["timeline", item.pk],
    queryFn: async (): Promise<Array<IItemTimeline>> => {
      const response = await TEVService.get(
        `/itemdata/${item.pk}/timeline/`
      );
      return response.data;
    },
  });

  if (timelineQuery.isLoading || timelineQuery.data === undefined) {
    return <LoadingAnimation />;
  }

  return (
    <Timeline
      items={
        timelineQuery.data.map(
          (event, index) => ({
            children: <TimelineEvent event={event} key={`event-${index}`} />,
            key: index,
            color: event.color || "blue"
          })
        )
      }
    />
  );
};
